import React from 'react';
import {makeStyles} from '@material-ui/core';
import {GreatTable, ImageWrapper} from 'components/common';
import {buildMediaFileUrl, levelMap} from 'utils/common';

const useStyles = makeStyles({
  tableCell: {
    whiteSpace: 'nowrap',
    textAlign: 'center',
  },
});

const CommonImageTable = (props) => {
  const classes = useStyles();
  return (
    <GreatTable
      {...props}
      itemName="image"
      getFieldsMapping={({versionCode, level, order, image}) => ({
        versionCode,
        level: levelMap[level],
        order,
        image,
      })}
      getFieldsSettings={() => ({
        versionCode: {
          fieldText: 'Version Code',
        },
        level: {
          fieldText: 'Level',
        },
        order: {
          fieldText: 'Order',
        },
        image: {
          fieldText: 'Image',
          formatData: (cell) => (
            <ImageWrapper height={100}>
              <img src={buildMediaFileUrl({url: cell})} />
            </ImageWrapper>
          ),
        },
      })}
    />
  );
};

export default CommonImageTable;
